/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type { MonsterLib, MonsterLibInterface } from "../MonsterLib";

const _abi = [
  {
    inputs: [
      {
        internalType: "int256",
        name: "value",
        type: "int256",
      },
    ],
    name: "IntValueOutOfRange",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "atype",
        type: "uint256",
      },
    ],
    name: "NotAType",
    type: "error",
  },
  {
    inputs: [],
    name: "NotMagic",
    type: "error",
  },
  {
    inputs: [],
    name: "NotYourAttackItem",
    type: "error",
  },
  {
    inputs: [],
    name: "NotYourBuffItem",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "chance",
        type: "uint32",
      },
    ],
    name: "TooHighChance",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "TooHighValue",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "x",
        type: "uint256",
      },
    ],
    name: "TooLowX",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "attackType",
        type: "uint256",
      },
    ],
    name: "UnknownAttackType",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        components: [
          {
            components: [
              {
                components: [
                  {
                    internalType: "int32[]",
                    name: "fighterAttributes",
                    type: "int32[]",
                  },
                  {
                    components: [
                      {
                        internalType: "uint32",
                        name: "level",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "experience",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "life",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "mana",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "lifeChances",
                        type: "uint32",
                      },
                    ],
                    internalType: "struct IStatController.ChangeableStats",
                    name: "fighterStats",
                    type: "tuple",
                  },
                  {
                    internalType: "enum IFightCalculator.AttackType",
                    name: "attackType",
                    type: "uint8",
                  },
                  {
                    internalType: "address",
                    name: "attackToken",
                    type: "address",
                  },
                  {
                    internalType: "uint256",
                    name: "attackTokenId",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "race",
                    type: "uint256",
                  },
                ],
                internalType: "struct IFightCalculator.FighterInfo",
                name: "info",
                type: "tuple",
              },
              {
                components: [
                  {
                    internalType: "enum IItemController.AttackType",
                    name: "aType",
                    type: "uint8",
                  },
                  {
                    internalType: "int32",
                    name: "min",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "max",
                    type: "int32",
                  },
                  {
                    components: [
                      {
                        internalType: "int32",
                        name: "strength",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "dexterity",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "vitality",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "energy",
                        type: "int32",
                      },
                    ],
                    internalType: "struct IStatController.CoreAttributes",
                    name: "attributeFactors",
                    type: "tuple",
                  },
                ],
                internalType: "struct IItemController.AttackInfo",
                name: "magicAttack",
                type: "tuple",
              },
              {
                internalType: "int32",
                name: "health",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "manaConsumed",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damage",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damagePoison",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damageReflect",
                type: "int32",
              },
              {
                components: [
                  {
                    internalType: "bool",
                    name: "stun",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "burn",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "freeze",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "confuse",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "curse",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "poison",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "gotCriticalHit",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "missed",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "hitBlocked",
                    type: "bool",
                  },
                ],
                internalType: "struct IFightCalculator.Statuses",
                name: "statuses",
                type: "tuple",
              },
            ],
            internalType: "struct IFightCalculator.Fighter",
            name: "fighterA",
            type: "tuple",
          },
          {
            components: [
              {
                components: [
                  {
                    internalType: "int32[]",
                    name: "fighterAttributes",
                    type: "int32[]",
                  },
                  {
                    components: [
                      {
                        internalType: "uint32",
                        name: "level",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "experience",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "life",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "mana",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "lifeChances",
                        type: "uint32",
                      },
                    ],
                    internalType: "struct IStatController.ChangeableStats",
                    name: "fighterStats",
                    type: "tuple",
                  },
                  {
                    internalType: "enum IFightCalculator.AttackType",
                    name: "attackType",
                    type: "uint8",
                  },
                  {
                    internalType: "address",
                    name: "attackToken",
                    type: "address",
                  },
                  {
                    internalType: "uint256",
                    name: "attackTokenId",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "race",
                    type: "uint256",
                  },
                ],
                internalType: "struct IFightCalculator.FighterInfo",
                name: "info",
                type: "tuple",
              },
              {
                components: [
                  {
                    internalType: "enum IItemController.AttackType",
                    name: "aType",
                    type: "uint8",
                  },
                  {
                    internalType: "int32",
                    name: "min",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "max",
                    type: "int32",
                  },
                  {
                    components: [
                      {
                        internalType: "int32",
                        name: "strength",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "dexterity",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "vitality",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "energy",
                        type: "int32",
                      },
                    ],
                    internalType: "struct IStatController.CoreAttributes",
                    name: "attributeFactors",
                    type: "tuple",
                  },
                ],
                internalType: "struct IItemController.AttackInfo",
                name: "magicAttack",
                type: "tuple",
              },
              {
                internalType: "int32",
                name: "health",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "manaConsumed",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damage",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damagePoison",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damageReflect",
                type: "int32",
              },
              {
                components: [
                  {
                    internalType: "bool",
                    name: "stun",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "burn",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "freeze",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "confuse",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "curse",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "poison",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "gotCriticalHit",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "missed",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "hitBlocked",
                    type: "bool",
                  },
                ],
                internalType: "struct IFightCalculator.Statuses",
                name: "statuses",
                type: "tuple",
              },
            ],
            internalType: "struct IFightCalculator.Fighter",
            name: "fighterB",
            type: "tuple",
          },
        ],
        indexed: false,
        internalType: "struct IFightCalculator.FightInfoInternal",
        name: "result",
        type: "tuple",
      },
      {
        components: [
          {
            components: [
              {
                internalType: "int32[]",
                name: "fighterAttributes",
                type: "int32[]",
              },
              {
                components: [
                  {
                    internalType: "uint32",
                    name: "level",
                    type: "uint32",
                  },
                  {
                    internalType: "uint32",
                    name: "experience",
                    type: "uint32",
                  },
                  {
                    internalType: "uint32",
                    name: "life",
                    type: "uint32",
                  },
                  {
                    internalType: "uint32",
                    name: "mana",
                    type: "uint32",
                  },
                  {
                    internalType: "uint32",
                    name: "lifeChances",
                    type: "uint32",
                  },
                ],
                internalType: "struct IStatController.ChangeableStats",
                name: "fighterStats",
                type: "tuple",
              },
              {
                internalType: "enum IFightCalculator.AttackType",
                name: "attackType",
                type: "uint8",
              },
              {
                internalType: "address",
                name: "attackToken",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "attackTokenId",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "race",
                type: "uint256",
              },
            ],
            internalType: "struct IFightCalculator.FighterInfo",
            name: "fighterA",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "int32[]",
                name: "fighterAttributes",
                type: "int32[]",
              },
              {
                components: [
                  {
                    internalType: "uint32",
                    name: "level",
                    type: "uint32",
                  },
                  {
                    internalType: "uint32",
                    name: "experience",
                    type: "uint32",
                  },
                  {
                    internalType: "uint32",
                    name: "life",
                    type: "uint32",
                  },
                  {
                    internalType: "uint32",
                    name: "mana",
                    type: "uint32",
                  },
                  {
                    internalType: "uint32",
                    name: "lifeChances",
                    type: "uint32",
                  },
                ],
                internalType: "struct IStatController.ChangeableStats",
                name: "fighterStats",
                type: "tuple",
              },
              {
                internalType: "enum IFightCalculator.AttackType",
                name: "attackType",
                type: "uint8",
              },
              {
                internalType: "address",
                name: "attackToken",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "attackTokenId",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "race",
                type: "uint256",
              },
            ],
            internalType: "struct IFightCalculator.FighterInfo",
            name: "fighterB",
            type: "tuple",
          },
          {
            internalType: "uint64",
            name: "dungeonId",
            type: "uint64",
          },
          {
            internalType: "uint32",
            name: "objectId",
            type: "uint32",
          },
          {
            internalType: "address",
            name: "heroAdr",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "heroId",
            type: "uint256",
          },
          {
            internalType: "uint8",
            name: "stageId",
            type: "uint8",
          },
          {
            internalType: "uint256",
            name: "iteration",
            type: "uint256",
          },
          {
            internalType: "uint8",
            name: "turn",
            type: "uint8",
          },
        ],
        indexed: false,
        internalType: "struct IFightCalculator.FightCall",
        name: "callData",
        type: "tuple",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "iteration",
        type: "uint256",
      },
    ],
    name: "FightResultProcessed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint48",
        name: "fightId",
        type: "uint48",
      },
      {
        indexed: false,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        components: [
          {
            components: [
              {
                components: [
                  {
                    internalType: "int32[]",
                    name: "fighterAttributes",
                    type: "int32[]",
                  },
                  {
                    components: [
                      {
                        internalType: "uint32",
                        name: "level",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "experience",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "life",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "mana",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "lifeChances",
                        type: "uint32",
                      },
                    ],
                    internalType: "struct IStatController.ChangeableStats",
                    name: "fighterStats",
                    type: "tuple",
                  },
                  {
                    internalType: "enum IFightCalculator.AttackType",
                    name: "attackType",
                    type: "uint8",
                  },
                  {
                    internalType: "address",
                    name: "attackToken",
                    type: "address",
                  },
                  {
                    internalType: "uint256",
                    name: "attackTokenId",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "race",
                    type: "uint256",
                  },
                ],
                internalType: "struct IFightCalculator.FighterInfo",
                name: "info",
                type: "tuple",
              },
              {
                components: [
                  {
                    internalType: "enum IItemController.AttackType",
                    name: "aType",
                    type: "uint8",
                  },
                  {
                    internalType: "int32",
                    name: "min",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "max",
                    type: "int32",
                  },
                  {
                    components: [
                      {
                        internalType: "int32",
                        name: "strength",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "dexterity",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "vitality",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "energy",
                        type: "int32",
                      },
                    ],
                    internalType: "struct IStatController.CoreAttributes",
                    name: "attributeFactors",
                    type: "tuple",
                  },
                ],
                internalType: "struct IItemController.AttackInfo",
                name: "magicAttack",
                type: "tuple",
              },
              {
                internalType: "int32",
                name: "health",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "manaConsumed",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damage",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damagePoison",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damageReflect",
                type: "int32",
              },
              {
                components: [
                  {
                    internalType: "bool",
                    name: "stun",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "burn",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "freeze",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "confuse",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "curse",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "poison",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "gotCriticalHit",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "missed",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "hitBlocked",
                    type: "bool",
                  },
                ],
                internalType: "struct IFightCalculator.Statuses",
                name: "statuses",
                type: "tuple",
              },
            ],
            internalType: "struct IFightCalculator.Fighter",
            name: "fighterA",
            type: "tuple",
          },
          {
            components: [
              {
                components: [
                  {
                    internalType: "int32[]",
                    name: "fighterAttributes",
                    type: "int32[]",
                  },
                  {
                    components: [
                      {
                        internalType: "uint32",
                        name: "level",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "experience",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "life",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "mana",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "lifeChances",
                        type: "uint32",
                      },
                    ],
                    internalType: "struct IStatController.ChangeableStats",
                    name: "fighterStats",
                    type: "tuple",
                  },
                  {
                    internalType: "enum IFightCalculator.AttackType",
                    name: "attackType",
                    type: "uint8",
                  },
                  {
                    internalType: "address",
                    name: "attackToken",
                    type: "address",
                  },
                  {
                    internalType: "uint256",
                    name: "attackTokenId",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "race",
                    type: "uint256",
                  },
                ],
                internalType: "struct IFightCalculator.FighterInfo",
                name: "info",
                type: "tuple",
              },
              {
                components: [
                  {
                    internalType: "enum IItemController.AttackType",
                    name: "aType",
                    type: "uint8",
                  },
                  {
                    internalType: "int32",
                    name: "min",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "max",
                    type: "int32",
                  },
                  {
                    components: [
                      {
                        internalType: "int32",
                        name: "strength",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "dexterity",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "vitality",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "energy",
                        type: "int32",
                      },
                    ],
                    internalType: "struct IStatController.CoreAttributes",
                    name: "attributeFactors",
                    type: "tuple",
                  },
                ],
                internalType: "struct IItemController.AttackInfo",
                name: "magicAttack",
                type: "tuple",
              },
              {
                internalType: "int32",
                name: "health",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "manaConsumed",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damage",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damagePoison",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damageReflect",
                type: "int32",
              },
              {
                components: [
                  {
                    internalType: "bool",
                    name: "stun",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "burn",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "freeze",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "confuse",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "curse",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "poison",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "gotCriticalHit",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "missed",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "hitBlocked",
                    type: "bool",
                  },
                ],
                internalType: "struct IFightCalculator.Statuses",
                name: "statuses",
                type: "tuple",
              },
            ],
            internalType: "struct IFightCalculator.Fighter",
            name: "fighterB",
            type: "tuple",
          },
        ],
        indexed: false,
        internalType: "struct IFightCalculator.FightInfoInternal",
        name: "result",
        type: "tuple",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "turn",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "heroA",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroIdA",
        type: "uint256",
      },
    ],
    name: "PvpFightResultProcessed",
    type: "event",
  },
] as const;

export class MonsterLib__factory {
  static readonly abi = _abi;
  static createInterface(): MonsterLibInterface {
    return new Interface(_abi) as MonsterLibInterface;
  }
  static connect(address: string, runner?: ContractRunner | null): MonsterLib {
    return new Contract(address, _abi, runner) as unknown as MonsterLib;
  }
}
